module.exports = __webpack_public_path__ + "img/icon-visa.90cd3539.svg";